import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import { map } from "lodash";
import { memo, useMemo } from "react";

const containerStyle = {
  width: "100%",
  height: "500px",
};

type MapsProps = {
  data: any[];
  onClick: (item: any) => void;
  style?: React.CSSProperties;
};

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
};

const MapsComponent = ({ style, data, onClick }: MapsProps) => {
  const center = useMemo(() => {
    let latitude = -22.9058338;
    let longitude = -47.0663981;
    navigator?.geolocation?.getCurrentPosition((resp) => {
      latitude = resp.coords.latitude;
      longitude = resp.coords.longitude;
    });
    return { lat: latitude, lng: longitude };
  }, []);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyAFnRCI6kHw0ICofnhMoI9zI2B0HexETeU",
    libraries: ["visualization", "geometry", "drawing", "places"],
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ ...containerStyle, ...style }}
      center={center}
      zoom={4}
    >
      <MarkerClusterer options={options}>
        {(clusterer) =>
          //@ts-ignore
          map(data, (dt, index) => (
            <Marker
              onClick={() => onClick(dt)}
              key={index.toString()}
              position={{ lat: Number(dt.lat), lng: Number(dt.lng) }}
              clusterer={clusterer}
            />
          ))
        }
      </MarkerClusterer>
    </GoogleMap>
  ) : (
    <></>
  );
};

export const Maps = memo(MapsComponent);
